(function () {
  function executeScripts(container) {
    const scripts = container.querySelectorAll('script');

    // Many embedded scripts (product gallery dots, loop/boundary checks, etc.) gate their own
    // init behind 'DOMContentLoaded' — fine for a real page load, but that event already fired
    // once on the ORIGINAL page and never fires again, so replaying those scripts as-is would
    // leave them permanently uninitialized (the swapped-in gallery would look broken/inert even
    // though its HTML is correct). The document is provably already ready at this point, so
    // intercept 'DOMContentLoaded' registrations made DURING this replay and run them immediately.
    const nativeAddEventListener = document.addEventListener.bind(document);
    document.addEventListener = function (type, listener, options) {
      if (type === 'DOMContentLoaded') {
        try {
          if (typeof listener === 'function') listener();
          else if (listener && typeof listener.handleEvent === 'function') listener.handleEvent();
        } catch (err) {
          console.warn('Error running a deferred DOMContentLoaded handler during print swap:', err);
        }
        return;
      }
      return nativeAddEventListener(type, listener, options);
    };

    try {
      scripts.forEach((oldScript, index) => {
        // External scripts (theme.js, vendor/app embeds) are already loaded once by the initial
        // page load and stay in <head> across the swap — re-inserting them as a live <script>
        // tag would re-fetch and re-run app/vendor code never designed for a second execution
        // (duplicate customElements.define, duplicate global listeners, etc.).
        if (oldScript.src) return;
        if (oldScript.type && !/^(text|application)\/javascript$/.test(oldScript.type)) return;

        try {
          // Run via Function(...) rather than re-inserting a live <script> tag. Classic <script>
          // tags share ONE page-level lexical scope, so any embedded script (ours or an app's)
          // that declares a top-level `const`/`let` without its own IIFE wrapper throws
          // "already been declared" the moment it runs a second time after an earlier swap.
          // Function() gives each run its own scope, avoiding that collision. It also makes the
          // script's own runtime errors real, catchable exceptions here — a <script> tag's
          // runtime errors bypass this try/catch entirely and surface as noisy uncaught
          // top-level errors instead, which is what a broken/stale script was doing before.
          // The sourceURL comment names each replayed script by position so a failure here
          // points at a specific script instead of an anonymous eval frame.
          new Function(oldScript.textContent + '\n//# sourceURL=print-swap-script-' + index + '.js')();
        } catch (err) {
          console.warn('Skipped re-running a script during print swap (script #' + index + '):', err, oldScript.textContent.slice(0, 120));
        }
      });
    } finally {
      document.addEventListener = nativeAddEventListener;
    }
  }

  async function swapProduct(trigger) {
    const url = trigger.dataset.productUrl;
    const productWrapper = document.querySelector('[id^="MainProduct-"]');

    if (!url || !productWrapper) {
      window.location.href = url;
      return;
    }

    productWrapper.setAttribute('aria-busy', 'true');
    productWrapper.classList.add('is-loading');

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error('Network response was not ok');

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newProductWrapper = doc.querySelector('.product[data-section-id]');

      if (!newProductWrapper) throw new Error('Could not find .product in response');

      const currentSectionId = productWrapper.dataset.sectionId;
      const newSectionId = newProductWrapper.dataset.sectionId;

      if (newSectionId && currentSectionId && newSectionId !== currentSectionId) {
        newProductWrapper.innerHTML = newProductWrapper.innerHTML.split(newSectionId).join(currentSectionId);
        newProductWrapper.dataset.sectionId = currentSectionId;
      }
      productWrapper.replaceWith(newProductWrapper);
      executeScripts(newProductWrapper); // <-- re-run any inline scripts now that the node is live

      window.history.pushState({ printSwap: true, url }, '', url);
      document.dispatchEvent(new CustomEvent('print:swapped', { detail: { url } }));
    } catch (err) {
      console.error('Print swap failed, falling back to full navigation:', err);
      window.location.href = url;
    }
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-print-swap');
    if (!trigger) return;
    event.preventDefault();
    swapProduct(trigger);
  }, true);

  window.addEventListener('popstate', (event) => {
    if (event.state && event.state.printSwap) {
      const trigger = document.createElement('a');
      trigger.dataset.productUrl = event.state.url;
      swapProduct(trigger);
    }
  });
})();
// (function () {
//   function expandThumbnails(nav) {
//     const thumbs = Array.from(nav.querySelectorAll('.product-gallery__thumbnail'));
//     thumbs.forEach((thumb) => {
//       thumb.removeAttribute('hidden');
//     });

//     const overlay = nav.querySelector('.product-gallery__thumbnail-more-overlay');
//     if (overlay) {
//       overlay.remove();
//     }

//     nav.dataset.expanded = 'true';
//   }

//   document.addEventListener('click', (event) => {
//     const overlay = event.target.closest('.product-gallery__thumbnail-more-overlay');
//     if (!overlay) return;

//     const nav = overlay.closest('.product-gallery__thumbnail-list');
//     if (!nav) return;

//     event.preventDefault();
//     event.stopPropagation();
//     event.stopImmediatePropagation();

//     expandThumbnails(nav);
//   }, true);
// })();
(function () {
  function syncThumbnailHeight(gallery) {
    const imageList = gallery.querySelector('.product-gallery__image-list');
    const thumbnailList = gallery.querySelector('.product-gallery__thumbnail-list');
    if (!imageList || !thumbnailList) return;

    thumbnailList.style.setProperty(
      '--product-gallery-thumbnail-list-max-height',
      `${imageList.offsetHeight}px`
    );
  }

  function initThumbnailHeightSync() {
    document.querySelectorAll('product-gallery').forEach((gallery) => {
      const imageList = gallery.querySelector('.product-gallery__image-list');
      if (!imageList) return;

      const alreadySynced = gallery.dataset.heightSyncBound === 'true';

      if (window.ResizeObserver) {
        const observer = new ResizeObserver(() => syncThumbnailHeight(gallery));
        observer.observe(imageList);
      }

      // Inline script (in product-gallery.liquid) already ran the first
      // sync at parse-time to avoid a flash of unsynced height. Only
      // run it here as a fallback if that inline script didn't fire
      // (e.g. gallery injected dynamically after initial page load).
      if (!alreadySynced) {
        syncThumbnailHeight(gallery);
      }

      gallery.dataset.heightSyncBound = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initThumbnailHeightSync);
  } else {
    initThumbnailHeightSync();
  }

  document.addEventListener('print:swapped', () => {
    setTimeout(initThumbnailHeightSync, 50);
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initThumbnailHeightSync);
  }
})();
(function () {
  function refreshJudgeMe() {
    if (typeof window.jdgm === 'undefined') return;

    // Different Judge.me app versions expose slightly different refresh methods —
    // call whichever is available.
    if (typeof window.jdgm.batchOwnerRefresh === 'function') {
      window.jdgm.batchOwnerRefresh();
    } else if (typeof window.jdgm.initializeWidgets === 'function') {
      window.jdgm.initializeWidgets();
    } else if (typeof window.jdgm.getBadges === 'function') {
      // Fallback used by some older Judge.me builds
      window.jdgm.getBadges();
    }
  }

  document.addEventListener('print:swapped', function () {
    // Give the new DOM a tick to settle before Judge.me re-scans it
    setTimeout(refreshJudgeMe, 50);
  });
})();